import styled from 'styled-components'
import fonts from '../../tokens/fonts'
import colors from '../../tokens/colors'
import border from '../../tokens/border'
import typography from '../../tokens/typography'
import layout from '../../tokens/layout'
import ShadowToken from '../../tokens/shadow'

interface CardContainerProps {
  theme?: 'default' | 'light' | 'negative'
}

export const CardContainer = styled.div<CardContainerProps>`
  display: grid;
  min-width: 18rem;
  height: 7rem;
  border: ${border.width.widthHairline} solid ${colors.neutralColorLowLight};
  padding: ${layout.padding.spacingInsetNano} ${layout.padding.spacingInsetXs};
  border-radius: ${border.radius.radiusSm};
  margin-left: ${layout.margin.spacingXxs};
  box-shadow: ${ShadowToken.shadowLevel1};
  background-color: ${(props) =>
    props.theme === 'light' && `${colors.neutralColorHighPure}`};
  background-color: ${(props) =>
    props.theme === 'negative' && `${colors.feedbackColorNegativePure}`};
  color: ${colors.neutralColorLowPure};
  color: ${(props) =>
    props.theme === 'negative' && `${colors.neutralColorHighPure}`};
`
export const Title = styled.div`
  font-size: ${typography.fontSize.fontSizeXs};
  font-weight: ${typography.fontWeight.fontWeightBold};
  font-family: ${fonts.inter};
  line-height: ${typography.fontHeight.lineHeightLg};
`
export const Description = styled.div`
  font-size: ${typography.fontSize.fontSizeXs};
  font-weight: ${typography.fontWeight.fontWeightRegular};
  font-family: ${fonts.inter};
  line-height: ${typography.fontHeight.lineHeightLg};
`
